var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.086 12.02 1.896 1.893-2.55.653.654-2.546Zm3.062 1.361-2.531-2.527 8.411-8.412 2.528 2.529-8.408 8.41ZM13 1.201c.199-.009.47.042.692.132v.001a1.767 1.767 0 0 1 .973.974c.09.22.136.451.133.69 0 .238-.048.47-.141.688a1.79 1.79 0 0 1-.265.423l-2.504-2.503c.13-.105.269-.198.424-.264.218-.092.45-.14.688-.142Zm2.776.652a2.957 2.957 0 0 0-1.63-1.63 2.975 2.975 0 0 0-2.303.015 2.98 2.98 0 0 0-.967.658L1.34 10.433c-.006.006-.007.016-.013.023a.589.589 0 0 0-.123.217c-.005.013-.017.022-.021.036L.019 15.251a.601.601 0 0 0 .73.73l4.542-1.166c.014-.003.023-.016.037-.02a.585.585 0 0 0 .23-.131c.003-.003.006-.003.009-.005l.002-.003.005-.003c0-.001 0-.003.002-.004l9.253-9.253c.002 0 .002-.002.002-.002l.268-.268a2.992 2.992 0 0 0 .678-3.273Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.84cfb17b5c73fdb01d2f3f6936f5f5fb.svg";
export { ForwardRef as ReactComponent };